import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A4DF4624-753B-440B-98C9-A25EE330B0AE
 * name lightbulb-spot-off
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lightbulb-spot-off.svg
 * tags
 * - Home Automation 
 */
export const LightbulbSpotOffIcon = createSvgIcon(<><path d="M20.84 22.73L15.11 17H9L9 14C6.5 12.57 4 11 4 6V5.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M22 4V2H5.2L7.2 4H22M20 6H9.2L16.37 13.17C18.33 11.87 20 10.07 20 6M13 22H15V19H13V22M9 22H11V19H9L9 22Z" /></>, 'LightbulbSpotOffIcon');
export default LightbulbSpotOffIcon